import { defaultTheme } from 'react-select';

// react-select's own default colours are a bright blue: the chosen option
// filled #2684FF, the hovered/keyboard one #DEEBFF, and a blue ring on the
// focused box. Selects that pass no theme of their own fell back to it. This
// swaps the default palette for the app's green, once, for every Select,
// Creatable and Async in the app — a theme passed to a Select still wins.
//
// The default theme is a shared object (Select spreads it into each
// instance's theme), so changing its colours here changes the default.
Object.assign(defaultTheme.colors, {
  primary: '#0e4535', // chosen option, focused box border and ring
  primary75: '#3f6b5e',
  primary50: '#a7c4b9', // option being pressed
  primary25: '#e8f0ed' // hovered / keyboard-focused option — the sidebar's hover green
});
